import PostRuleTask from './post-rule-task';
export default class PutRuleTask extends PostRuleTask {
    get url() {
        return `/rules/${this.rule.id}`;
    }
    get method() {
        return 'PUT';
    }
    get successCode() {
        return 200;
    }
}
//# sourceMappingURL=put-rule-task.js.map